<template>
  <div>
    <transition name="fade">
      <div :class="[ 'overlay' ]" v-if="open" v-on:click="close"></div>
    </transition>
    <transition name="slide">
      <div class="body" v-if="open">
        <div class="title">
          <button class="btn" type="button" v-on:click="close">
            <svg width="19px" height="16px" viewBox="0 0 19 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Suites-Availability-Add" transform="translate(-913.000000, -68.000000)">
                  <g id="Group-14" transform="translate(50.000000, 70.000000)"></g>
                  <g id="Back" transform="translate(922.500000, 76.000000) rotate(-270.000000) translate(-922.500000, -76.000000) translate(915.000000, 67.000000)" fill="#000000">
                    <polygon id="Path" points="13.2657054 9.9079646 8.2218255 14.9734513 8.12482781 0 6.63752989 0.0318584071 6.60519733 15.0371681 1.49665229 9.93982301 0.397345133 11.0230088 7.38117885 18 14.3973451 10.9911504"></polygon>
                  </g>
                </g>
              </g>
            </svg>
          </button>
          <span>View Notes</span>
        </div>
        <div v-if="isLoading" class="loading">
          <span class="spinner-border" role="status"></span>
        </div>
        <div v-else class="content">
          <div class="notes">
            <WaitlistNotesingle v-for="note in notes" v-bind:key="note.id" :note="note" :removedNote="removeNote" />
          </div>
          <div class="footer">
            <form v-on:submit.prevent="addNote">
              <div class="form-group">
                <textarea name="note" placeholder="Enter your notes" class="form-control" rows="6" v-model="noteText"></textarea>
              </div>
              <div class="form-group btn-group">
                <button type="submit" class="btn btn-red btn-block">
                  <span class="spinner-border spinner-border-sm" role="status" v-if="isLoadingAddNote"></span>
                  <span v-else>Add New Note</span>
                </button>
                <p v-if="error" class="error">{{ error }}</p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import WaitlistNotesingle from "./WaitlistNoteSingle.vue";

export default {
  name: 'WaitlistNotes',
  data: function () {
    return {
      notes: [],
      isLoading: false,
      noteText: "",
      error: "",
      isLoadingAddNote: false,
    };
  },
  props: ['open', 'close', 'waitlistId'],
  watch: {
    open: function (newVal, oldVal) {
      if (newVal == true && oldVal == false) {
        // get notes
        this.isLoading = true;
        axios.get(`/api/waitlist/${this.waitlistId}/notes/read`)
          .then((response) => {
            this.notes = response.data.notes;
          })
          .finally(() => {
            this.isLoading = false;
          })
      }
    }
  },
  methods: {
    addNote: function () {
      this.error = "";

      if (this.noteText.trim() == "") {
        this.error = "Please enter your note";
      }
      else {
        this.isLoadingAddNote = true;
        axios.post(`/api/waitlist/${this.waitlistId}/notes/create`, { note: this.noteText })
          .then((response) => {
            this.noteText = "";
            this.notes.push(response.data.note);
          })
          .catch((error) => {
            if (error.response) {
              let errorStr = "";
              if (error.response.data.error) {
                errorStr = error.response.data.error;
              }
              else if (error.response.data.errors) {
                errorStr = error.response.data.errors[Object.keys(error.response.data.errors)[0]][0];
              }
              else {
                errorStr = error.response.data.message;
              }

              this.error = errorStr;
            }
            else {
              this.error = "Sorry, something went wrong. Please try again later."
            }
          })
          .finally(() => {
            this.isLoadingAddNote = false;
          });
      }
    },
    removeNote: function (noteId) {
      for (let i = 0; i < this.notes.length; i++) {
        if (this.notes[i].id == noteId) {
          this.notes.splice(i, 1);
          break;
        }
      }
    },
  },
  components: {
    WaitlistNotesingle,
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables";

div.overlay {
  background: rgba(black, 0.5);
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

div.body {
  position: fixed;
  z-index: 11;
  right: 0;
  top: 0;
  bottom: 0;
  background: white;
  width: 550px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

div.title {
  display: flex;
  align-items: center;
  padding: 63px 57px 0px;
  position: relative;
  
  span {
    font-size: 1.25rem;
    font-weight: 500;
    color: #4A4A4A;
  }

  button {
    position: absolute;
    bottom: -3px;
    left: calc(1em);
  }
}

div.content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  flex-grow: 1;
  width: 100%;
}

div.notes {
  width: 100%;
}

div.footer {
  padding: 36px 57px 28px;
  background: #FFFFFF;
  box-shadow: -1px -1px 40px 0 rgba(0,0,0,0.13);
  width: 100%;
  margin-top: auto;

  div.btn-group {
    margin-top: 1.5rem;
    margin-bottom: 0;

    p.error {
      margin: 1rem 0 0;
      font-size: 0.875rem;
      color: $red;
      text-align: left;
    }
  }
}

div.loading {
  padding: 50px 0;
  text-align: center;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .25s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.slide-enter-active, .slide-leave-active {
  transition: transform .25s;
}
.slide-enter, .slide-leave-to {
  transform: translateX(550px);
}
</style>